// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1iaCJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__3yNUy"};